import { sanitizeRichHtml } from "@playbrain/content-types/richHtml"
import { PlaydataSection } from "@playdata/PlaydataPrimitives"

/**
 * Renders a legal document: a centred title, then the body as a single column
 * of prose. The body is markdown authored in the dashboard, rendered to HTML
 * server-side and sanitised on the way out — the same path the news detail
 * page uses.
 */
export function PlaydataLegalBody({ body, heading }: { body: string; heading: string }) {
  return (
    <PlaydataSection>
      <h1 className="mb-[4rem] text-center text-[2.8rem] md:text-[3.4rem]">
        <strong>{heading}</strong>
      </h1>
      {body ? (
        <div
          className="playdata-prose mx-auto flex max-w-[72ch] flex-col gap-[1.4rem] text-[1.5rem] leading-[1.8]"
          dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(body) }}
        />
      ) : null}
    </PlaydataSection>
  )
}

export default PlaydataLegalBody
